import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'htmlEntities'
})
export class HtmlEntitiesPipe implements PipeTransform {

  transform(encodedString: string): string {
    const translateRe = /&(nbsp|amp|quot|lt|gt);/g;
    const translate = {
        nbsp: ' ',
        amp : '&',
        quot: '"',
        lt  : '<',
        gt  : '>'
    };
    return encodedString.replace(translateRe, (match, entity) => {
        return translate[entity];
    }).replace(/&#(\d+);/gi, (match, numStr) => {
      const num = parseInt(numStr, 10);
      return String.fromCharCode(num);
    });
  }
}
